import React from 'react';
import { SvgIcon, useTheme } from '@mui/material';

export default function CaretDownIcon(props) {
  const theme = useTheme();

  return (
    <SvgIcon inheritViewBox {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="19"
        height="11"
        viewBox="0 0 19 11"
        fill="none"
      >
        <path
          d="M1.5 1.5L9.5 9.5L17.5 1.5"
          stroke={theme.palette.main.professional_blue}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </SvgIcon>
  );
}
